var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('client-only',[_c('div',{staticClass:"cn-tips-section"},[_c('div',{staticClass:"container"},[(_setup.isDesktop)?_c('TipsSectionTabs',{attrs:{"tabs":_vm.data}}):_c('TipsSectionAccordion',{attrs:{"tabs":_vm.data}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }